export { default } from './TasksAccountSettingsService';



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/tasks/services/TasksAccountSettingsService/index.js